import { render, staticRenderFns } from "./add_Keyword.vue?vue&type=template&id=048e0262&scoped=true"
import script from "./add_Keyword.vue?vue&type=script&lang=js"
export * from "./add_Keyword.vue?vue&type=script&lang=js"
import style0 from "./add_Keyword.vue?vue&type=style&index=0&id=048e0262&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e0262",
  null
  
)

export default component.exports